import type {BioIconProps} from '../../icons/common-types'
import {FlagIconByLocale} from '../../icons/flag-icons-by-locale'

export default function TopOnlineReviewsLogo({locale, ...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-2 text-2xl font-semibold text-white tablet:gap-1 tablet:text-base">
      <svg {...attributes} width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1107_9888)">
          <path
            d="M25.9012 27.7026L17.4612 15.1826L9.02124 27.7026H13.9912V32.1926H20.9312V27.7026H25.9012Z"
            fill="white"
          />
          <path
            d="M18.6212 4.70257L19.4412 7.22257H22.0912C22.8912 7.22257 23.2312 8.25257 22.5812 8.72257L20.4412 10.2826L21.2612 12.8026C21.5112 13.5626 20.6312 14.2026 19.9812 13.7326L17.8412 12.1726L15.7012 13.7326C15.0512 14.2026 14.1812 13.5726 14.4212 12.8026L15.2412 10.2826L13.1012 8.72257C12.4512 8.25257 12.7812 7.22257 13.5912 7.22257H16.2412L17.0612 4.70257C17.3112 3.94257 18.3912 3.94257 18.6412 4.70257H18.6212Z"
            fill="white"
          />
          <path
            d="M25.4813 12.5325L25.8713 13.7225H27.1213C27.6513 13.7225 27.8713 14.4025 27.4413 14.7125L26.4313 15.4525L26.8213 16.6425C26.9813 17.1425 26.4113 17.5625 25.9813 17.2525L24.9713 16.5125L23.9613 17.2525C23.5313 17.5625 22.9613 17.1425 23.1213 16.6425L23.5113 15.4525L22.5013 14.7125C22.0713 14.4025 22.2913 13.7225 22.8213 13.7225H24.0713L24.4613 12.5325C24.6213 12.0325 25.3413 12.0325 25.5013 12.5325H25.4813Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1107_9888">
            <rect width="18.65" height="28.06" fill="white" transform="translate(9.02124 4.13257)" />
          </clipPath>
        </defs>
      </svg>
      <span>Top Online Reviews</span>
      <FlagIconByLocale
        locale={locale}
        className="absolute -right-6 -top-2 size-7 shrink-0 -rotate-12 tablet:-right-4 tablet:-top-1 tablet:size-5"
      />
    </div>
  )
}
